import { NavLink } from "react-router-dom";
import birthday from "../../../Assets/Events/2023/Banner_Images/banner_21.webp";
import BannerImg2 from "../../../Assets/Events/2026/Banner_Images/Holi_Banner_26.webp";
import BannerImg1 from "../../../Assets/Events/2026/Banner_Images/Republic_Day_Banner_26.webp";


const Events2026Banner = [
    {
        id: 1,
        bannerImage: <NavLink to={"/republic-day-2026"} className="href"><img src={BannerImg1} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/republic-day-2026"} className="href">Republic Day #2026</NavLink></h4>
    },
    {
        id: 2,
        bannerImage: <NavLink to={"/happy-holi-2026"} className="href"><img src={BannerImg2} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/happy-holi-2026"} className="href">Happy Holi #2026</NavLink></h4>
    },
    {
        id: 3,
        bannerImage: <NavLink to={"/birthday-celebration-2026"} className="href"><img src={birthday} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/birthday-celebration-2026"} className="href">Birthday Celebrations</NavLink></h4>
    }
    // {
    //     id: 5,
    //     bannerImage: <NavLink to={"/happy-independence-day-2025"} className="href"><img src={BannerImg5} alt="" className='img-fluid' /></NavLink>,
    //     bannerPara: <h4><NavLink to={"/happy-independence-day-2025"} className="href">Happy Independence Day #2025</NavLink></h4>
    // },
    // {
    //     id: 6,
    //     bannerImage: <NavLink to={"/happy-diwali-2025"} className="href"><img src={BannerImg7} alt="" className='img-fluid' /></NavLink>,
    //     bannerPara: <h4><NavLink to={"/happy-diwali-2025"} className="href">Happy Diwali #2025</NavLink></h4>
    // },
    // {
    //     id: 7,
    //     bannerImage: <NavLink to={"/karnataka-rajyotsava-2025"} className="href"><img src={BannerImg8} alt="" className='img-fluid' /></NavLink>,
    //     bannerPara: <h4><NavLink to={"/karnataka-rajyotsava-2025"} className="href">Karnataka Rajyotsava #2025</NavLink></h4>
    // },
    // {
    //     id: 8,
    //     bannerImage: <NavLink to={"/christmas-2025"} className="href"><img src={BannerImg9} alt="" className='img-fluid' /></NavLink>,
    //     bannerPara: <h4><NavLink to={"/christmas-2025"} className="href">Christmas #2025</NavLink></h4>
    // },
];

export default Events2026Banner;